import * as React from 'react';
import styles from './Footer.module.scss';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import WhapsAppIcon from '../../../components/style-guide/icons/WhatAppIcon';
import PhoneIcon from '../../../components/style-guide/icons/PhoneIcon';
import MailIcon from '../../../components/style-guide/icons/MailIcon';

export const Footer = (props) => {
  const inlineStyle = 'px-2';
  const titleStyle = 'p-1 mb-0';
  const wrapRowStyle = 'd-flex flex-wrap';

  const {
    copyright = '© TODOS LOS DERECHOS RESERVADOS',
    copyrightInfoDate = 'Asesorías DOX, 2020',
    visitWebsite1 = 'www.totalcheck.cl',
    visitWebsite2 = 'www.dox.cl',
    email = 'soporte-idauto@dox.cl',
    phone = '+56 2 6543 8765',
    whatsapp = '+56 999846063'
  } = props;

  return (
    <footer className={styles.footer}>
      <div className="d-flex flex-wrap" style={{maxWidth: '1200px', margin: 'auto'}}>
        <div className="flex-fill">
          <label className={titleStyle}>CONTÁCTENOS</label>
          <div className={wrapRowStyle}>
            <span className={inlineStyle}>
              <span className={styles.inlineIcon}>
                <MailIcon fontSize="small"/>
              </span>
              <a href={"mailto:" + email}>{email}</a>
            </span>
            <span className={inlineStyle}>
                <span className={styles.inlineIcon}>
                  <PhoneIcon fontSize="small"/>
                </span>
                <span>{'-'}</span>
            </span>
            <span className={inlineStyle}>
                <span className={styles.inlineIcon}>
                  <WhapsAppIcon fontSize="small"/>
                </span>
                <span>{whatsapp}</span>
            </span>
          </div>
        </div>

        <div className="flex-auto hidden md-flex flex-fill">
          <div className="flex-fill">
            <label className={titleStyle}>VISÍTENOS</label>
            <div className={wrapRowStyle}>
              <a className={inlineStyle} href={`http://${visitWebsite1}`} alt="sitio de interés"> {visitWebsite1}</a>
              <a className={inlineStyle} href={`http://${visitWebsite2}`}
                 alt="sitio oficial de la empresa"> {visitWebsite2}</a>
            </div>
          </div>
          <div className={clsx('flex-fill', styles.copyright)}>
            <div className="d-flex flex-column h-100">
              <p style={{marginTop: 'auto', paddingBottom: '0.5rem'}}> {copyright}</p>
              <p style={{marginBottom: 'auto'}}>{copyrightInfoDate}</p>
            </div>
          </div>
        </div>

        <div className="flex flex-auto md-hidden flex-fill">
          <div className="flex-fill">
            <label className={clsx(titleStyle)}>VISÍTENOS</label>
            <div className="flex-v-center flex-wrap" style={{ justifyContent: 'space-between' }}>
              <a className="ml-2" rel="noreferrer noopener" href={`http://${visitWebsite1}`} alt="sitio de interés" target="_blank"> {visitWebsite1}</a>
              <a className={inlineStyle} rel="noreferrer noopener" href={`http://${visitWebsite2}`}
                 alt="sitio oficial de la empresa" target="_blank"> {visitWebsite2}</a>
              <p className={inlineStyle} style={{marginBottom: 'auto'}}> {copyrightInfoDate}</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

Footer.propTypes = {
  copyright: PropTypes.string,
  copyrightInfoDate: PropTypes.string,
  visitWebsite1: PropTypes.string,
  visitWebsite2: PropTypes.string,
  email: PropTypes.string,
  phone: PropTypes.string,
  whatsapp: PropTypes.string,

};


export default React.memo(Footer);
